import B1 from "../../../Images/New/ImageView/1.jpg";
import B2 from "../../../Images/New/ImageView/2.jpg";
import B3 from "../../../Images/New/ImageView/3.jpg";
import B4 from "../../../Images/New/ImageView/4.jpg";
import B5 from "../../../Images/New/ImageView/5.png";
import B6 from "../../../Images/New/ImageView/6.png";
import B7 from "../../../Images/New/ImageView/7.jpg";
import B8 from "../../../Images/New/ImageView/8.png";

const moduleData = [
  {
    name: "Account Dashboard",
    back: B1,
  },
  {
    name: "GST base Invoicing",
    back: B2,
  },
  {
    name: "E-Invoice",
    back: B8,
  },
  {
    name: "Debit Note/Credit Note",
    back: B3,
  },
  {
    name: "Annual Final Statement",
    back: B4,
  },
  {
    name: "GST Reports & Analysis",
    back: B5,
  },
  {
    name: "Reports",
    back: B6,
  },
  {
    name: "Bank/Cash/Ledger/JV",
    back: B7,
  },
];

export default moduleData;

